export enum RoutesEnum {
  ROOT = '/',
  HOME = '/home',
  LEGAL = '/legal',
  PRIVACY = '/privacy',
  ABOUT = '/about',
  SERVICES = '/services',
}
